// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"8dcdf7b9","688":"bf06d601","989":"e9f1044c"}[chunkId] + ".chunk.js";
};